import { render, staticRenderFns } from "./SiteDocumentPage.vue?vue&type=template&id=63e53106"
import script from "./SiteDocumentPage.vue?vue&type=script&lang=js"
export * from "./SiteDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports